import React, { useState } from 'react';
import FoodSelectionModal from './activities/FoodSelectionModal';
import RecipeSelectionModal from './activities/RecipeSelectionModal';
import { CakeIcon, BeakerIcon } from '@heroicons/react/24/outline';
import './FoodsRecipesModal.css';

const FoodsRecipesModal = ({ close, backendService, modalService, initialTab = 'foods' }) => {
  const [tab, setTab] = useState(initialTab); // 'foods' | 'recipes'

  return (
    <div className="foods-recipes-modal">
      {/* Header - matches SocialModal / StrategyModal pattern */}
      <div className="frm-header">
        <h2>Foods &amp; Recipes</h2>
      </div>

      {/* Tabs - shared .modal-tabs / .modal-tab from App.css */}
      <div className="modal-tabs">
        <button
          className={`modal-tab ${tab === 'foods' ? 'active' : ''}`}
          onClick={() => setTab('foods')}
          title="Foods"
        >
          <CakeIcon style={{ width: 16, height: 16 }} /> Foods
        </button>
        <button
          className={`modal-tab ${tab === 'recipes' ? 'active' : ''}`}
          onClick={() => setTab('recipes')}
          title="Recipes"
        >
          <BeakerIcon style={{ width: 16, height: 16 }} /> Recipes
        </button>
      </div>

      {/* Body */}
      <div className="frm-body">
        {tab === 'foods' && (
          <FoodSelectionModal
            close={close}
            onSelect={() => {}}
            backendService={backendService}
            manageMode={true}
            embedded={true}
          />
        )}
        {tab === 'recipes' && (
          <RecipeSelectionModal
            close={close}
            onSelect={() => {}}
            backendService={backendService}
            modalService={modalService}
            manageMode={true}
            embedded={true}
          />
        )}
      </div>
    </div>
  );
};

FoodsRecipesModal.displayName = 'FoodsRecipesModal';

export default FoodsRecipesModal;
